// @flow

import React, { type Node } from 'react';
import { getSafeBoletoBarcode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { formatBoletoNumber } from '@tectonics/prs/boleto';

export function BoletoNumber(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <div style={BarcodeNumberStyle}>
      {formatBoletoNumber(getSafeBoletoBarcode(incomingPayment))}
    </div>
  );
}

const BarcodeNumberStyle = {
  textAlign: 'center',
  fontSize: '20px',
  fontWeight: '700',
  alignItems: 'center',
  color: '#737f93',
};
